export default {
  header: 'Are you sure you want to revoke access?',
  subText: (companyName) => `You\'ll need to follow ${companyName}'s directions if you want to reconnect.`,
  revokeButton: 'Revoke',
  cancelButton: 'Cancel'
};
